import React, { Component } from 'react';
import { Auth } from 'aws-amplify'; 
import {
  withRouter,
  Link
} from 'react-router-dom';
import {
  Nav,
  NavItem,
  Navbar,
  NavDropdown,
  Glyphicon
} from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
import './App.css';
import Routes from './Routes';
import '../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';



class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      approvedServices: [],
    };
  }

  // Loads the current user from browser session and sets isLoadingUserToken
  // Prevents the app from loading while still trying to determine login status
  async componentDidMount() {

    try {
      var session = await Auth.currentSession();
      console.log('session',session);
      if (session) {
        console.log('Auth.currentSession() valid')
        console.log()
        await this.userHasAuthenticated(true);
      }
    }
    catch(e) {
      if (e !== 'No current user') {
        console.error(e);
      }
      await this.userHasAuthenticated(false);
    }
    this.setState({ isAuthenticating: false });
  }

  userHasAuthenticated = async (authenticated) => {
    if (authenticated === true) {
      await this.populateApprovedServices(await this.getApprovedServicesWithAmplify());
    }
    this.setState({ isAuthenticated: authenticated });
  }

  populateApprovedServices = (approvedServices) => {
    approvedServices.push('default');
    this.setState({ approvedServices: approvedServices });

  }

  getApprovedServicesWithAmplify = async event => {
    var approvedServices = [];
    try {
      var session = await Auth.currentSession();
      if (session) {
        //console.log('Found user from Auth.currentAuthenticatedUser()');
        //console.log('User attributes:', attributes);
        console.log('Cognito Groups:',session.accessToken.payload['cognito:groups']);
        if (session.accessToken.payload['cognito:groups']) {
          approvedServices = session.accessToken.payload['cognito:groups']
        }
      }
    } catch (e) {
      console.error('Failed to get user attributes:', e);
    }
    return approvedServices;
  }

  // Signs out the user via Cognito API and clears user token
  handleLogout = async event => {
    
    await Auth.signOut();

    //signOutUser();
    this.userHasAuthenticated(false);
    this.populateApprovedServices([]);

    this.props.history.push('/login');
  }

  handleNavLink = (event) => {
    event.preventDefault();
    this.props.history.push(event.currentTarget.getAttribute('href'));
  }


  render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      approvedServices: this.state.approvedServices,
    };

    //return ! this.state.isLoadingUserToken && (
    return ! this.state.isAuthenticating && (
      <div className="App container">
        <Navbar fluid collapseOnSelect>
          <Navbar.Header>
            <Navbar.Brand>
              <div className="navbar-left-logo" >
                <Link to="/">
                  <img className="navbar-left-logo-img" src={"/hsx_alpha_icon.png"} alt="HSX" />
                  <p className="logo-text">Management App</p>
                </Link>
                <p className="logo-text-env">{process.env.NODE_ENV === 'development' ? '(' + process.env.REACT_APP_STAGE + ')' : null}</p>
              </div>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight className="pills-custom">
              {/* Non-production routes should have process.env.REACT_APP_STAGE != 'production' in ternary comparison */}
              {this.state.isAuthenticated && (this.state.approvedServices.indexOf('Administrators') > -1 || this.state.approvedServices.indexOf('Panels') > -1)
                ? <NavDropdown title="Panels" id="dropdown">
                    <LinkContainer to="/panels" exact><NavItem>Subscriber Panels</NavItem></LinkContainer>
                    <LinkContainer to="/panels/jobs" exact><NavItem>Panel Jobs</NavItem></LinkContainer>
                  </NavDropdown> : null}
              {this.state.isAuthenticated && (this.state.approvedServices.indexOf('Administrators') > -1 || this.state.approvedServices.indexOf('ProviderDirectory') > -1)
                ? <NavDropdown title="Provider Directory" id="dropdown">
                  <LinkContainer to="/providerdirectory/organizations" exact><NavItem>Organizations</NavItem></LinkContainer>
                  <LinkContainer to="/providerdirectory/config/ignore" exact><NavItem>Ignored Providers</NavItem></LinkContainer>
                </NavDropdown> : null}
              {this.state.isAuthenticated 
                ? <NavDropdown title={<Glyphicon glyph="cog" />} id="dropdown">
                    <LinkContainer to="/account"><NavItem>Manage Account</NavItem></LinkContainer>
                    <LinkContainer to="/about"><NavItem>About</NavItem></LinkContainer>
                    <NavItem onClick={this.handleLogout}>Logout</NavItem>
                  </NavDropdown>
                : <NavItem onClick={this.handleNavLink} href="/login">Login</NavItem>}
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <Routes childProps={childProps} />

      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js